export class SharedToastsService {
    static $inject = ['BlipToastService', '$translate', '$location'];
    constructor(BlipToastService, $translate, $location) {
        'ngInject';
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.$location = $location;
    }
    async showLeaveContractToast() {
        const { leaveContract } = this.$location.search();
        if (leaveContract) {
            this.BlipToastService.show('success', {
                title: (await this.$translate.instant('leaveContractToast.title')),
                msg: (await this.$translate.instant('leaveContractToast.message')),
                duration: 10000,
            });
        }
    }
    async showUploadErrorToast(code) {
        const PAYLOAD_TOO_LARGE = 413;
        const INVALID_MIME_TYPE = 415;
        const TOAST_DURATION = 8000;
        let title, msg;
        switch (code) {
            case PAYLOAD_TOO_LARGE:
                title = await this.$translate('uploadMediaError.largePayloadTitle');
                msg = await this.$translate('uploadMediaError.largePayloadContent');
                this.BlipToastService.show('danger', {
                    title,
                    msg,
                    duration: TOAST_DURATION,
                });
                break;
            case INVALID_MIME_TYPE:
                title = await this.$translate('uploadMediaError.invalidExtensionTitle');
                msg = await this.$translate('uploadMediaError.invalidExtensionContent');
                this.BlipToastService.show('danger', {
                    title,
                    msg,
                    duration: TOAST_DURATION,
                });
                break;
            default:
                title = await this.$translate('uploadMediaError.failedToUploadTitle');
                msg = await this.$translate('uploadMediaError.failedToUploadContent');
                this.BlipToastService.show('danger', {
                    title,
                    msg,
                    duration: TOAST_DURATION,
                });
                break;
        }
    }
}
SharedToastsService.$inject = ['BlipToastService', '$translate', '$location'];
